import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "global-module-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "globalModuleSettings" */ "GlobalModuleSettings/components"
      ),
      import(
        /* webpackChunkName: "globalModuleSettings" */ "GlobalModuleSettings/modules/GlobalModuleSettingsModule"
      ),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "globalModuleSettings",
          reducer,
        });
        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
});
